/**
 * @generated SignedSource<<305fab7a6461f9fd292289126cecdd6f>>
 * @relayHash 39209fae6b03316b5831f0337cfa59c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a911bfa308ab38586c38e65c38a450216a3c1f3d329c7b683d9ec41a1dbd4c99

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentBrowseIntentsQuery } from './srcVirtualAgentBrowseIntentsQuery.graphql';

const node: PreloadableConcreteRequest<srcVirtualAgentBrowseIntentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a911bfa308ab38586c38e65c38a450216a3c1f3d329c7b683d9ec41a1dbd4c99",
    "metadata": {},
    "name": "srcVirtualAgentBrowseIntentsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
